import httpClient from '@yola/http-client';
import composeAssetUrl from './compose-asset-url';

const fetchAsset = (source, options) => httpClient.get(composeAssetUrl(source, options));

export default fetchAsset;
